/* @flow weak */
import React from 'react';

import cx from 'classnames';

import './styles/MediaObject.scss';

class MediaObject extends React.Component {
  static propTypes = {
    center: React.PropTypes.bool,
    figure: React.PropTypes.oneOf(['left', 'right']),
    gutter: React.PropTypes.oneOf(['medium', 'small']),
    children(props, propName) {
      if (React.Children.count(props[propName]) !== 2) {
        return new Error('MediaObject expects two child elements');
      }
    },
  }

  static defaultProps = {
    center: false,
    figure: 'left',
    gutter: 'medium',
    allowOverflow: false,
  };

  static wrap(node) {
    if (React.isValidElement(node)) {
      return node;
    }
    return <div>{node}</div>;
  }

  render() {
    let [left, right] = this.props.children;

    if (this.props.figure === 'left') {
      left = MediaObject.wrap(left);
      left = React.cloneElement(left, {
        className: cx(
          'MediaObject-figure',
          left.props.className
        ),
      });

      right = MediaObject.wrap(right);
      right = React.cloneElement(right, {
        className: cx(
          'MediaObject-body',
          right.props.className
        ),
      });
    } else {
      right = MediaObject.wrap(right);
      right = React.cloneElement(right, {
        className: cx(
          'MediaObject-figure',
          right.props.className
        ),
      });
    }

    return (
      <div
        className={cx('MediaObject', {
          'MediaObject--center': this.props.center,
          'MediaObject--small': this.props.gutter === 'small',
        }, this.props.className)}>
        {left}
        {right}
      </div>
    );
  }
}

export default MediaObject;



// WEBPACK FOOTER //
// ./src/components/MediaObject.jsx